export default "__VITE_ASSET__Domh4zdD__"